import React from 'react'

const RoiCTA = () => {
    return (
        <>
            <div className="container-fluid bg-dark">
                <div className="container roi-calculator-strip">
                    <div className="d-flex align-items-center flex-wrap">
                        <div className="icon me-5 mb-3 mb-lg-0">
                            <i class="fa-solid fa-money-bill-trend-up text-light" style={{ fontSize: '60px' }}></i>
                        </div>
                        <div className="roi-label me-5 lh-1 d-flex flex-column justify-content-center mb-5 mb-lg-0">
                            <p className="fw-bold fs-3 fs-lg-5 text-light">ROI Calculator</p>
                            <p className='text-light fs-5 fs-lg-6 mb-0'>Calculate your fleet’s savings potential with Shoora.</p>
                        </div>
                        <div className="action">
                            <button className="btn btn-outline-light btn-lg rounded-5 fw-bold fs-6">See your ROI</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default RoiCTA